<template>
    <div class="lazy-image" @click="handlerClick" :class="{ 'hover-class': hoverClass }" ref="lazyImage" :style="{ 'border-radius': customStyle['border-radius'] }">
        <img @load="onLoad" alt="" :class="{ loaded }" draggable="false" :style="customStyle" v-if="canLoadingImg" :src="src" />
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true,
            default: ''
        },
        customStyle: {
            type: Object,
            default: () => ({})
        },
        className: {
            type: String,
            default: ''
        },
        hoverClass: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loaded: false,
            canLoadingImg: false
        }
    },
    mounted() {
        this.observer = new IntersectionObserver(this.handleIntersection, {
            root: null || document.getElementsByClassName(this.className)[0],
            threshold: 0.1
        })
        this.observer.observe(this.$refs.lazyImage)
    },
    methods: {
        onLoad() {
            this.loaded = true
        },
        handleIntersection(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.canLoadingImg = true
                    this.observer.unobserve(entry.target)
                }
            })
        },
        handlerClick() {
            this.$emit('click')
        }
    },
    beforeDestroy() {
        this.observer.disconnect()
        this.$refs.lazyImage.children[0].removeEventListener('load', this.onLoad)
    }
}
</script>

<style lang="less" scoped>
.lazy-image {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: @bg-color-1E url(../assets/lazy-img-bg.png) center/60px no-repeat;
}

.lazy-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: 1s;
}

.lazy-image.hover-class img:hover {
    transition: 0.3s;
    transform: scale(1.2);
}

.lazy-image img.loaded {
    opacity: 1;
}

.loader-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
